import type { en } from "../en";
import { common } from "./common";
import { nav } from "./nav";
import { dashboard } from "./dashboard";
import { guide } from "./guide";
import { onboarding } from "./onboarding";
import { reviewPrompt } from "./reviewPrompt";
import { quoteDetail } from "./quoteDetail";
import { quotes } from "./quotes";
import { quoteNew } from "./quoteNew";
import { quoteMisc } from "./quoteMisc";
import { companies } from "./companies";
import { priceLists } from "./priceLists";
import { poImports } from "./poImports";
import { ai } from "./ai";
import { settings } from "./settings";
import { feedback } from "./feedback";

// `: typeof en` makes locale parity a COMPILE ERROR: add/rename/remove a key
// in any English namespace and `tsc --noEmit` fails here until the Italian
// counterpart matches. `npm run typecheck` IS the translation-completeness test.
export const it: typeof en = {
  common,
  nav,
  dashboard,
  guide,
  onboarding,
  reviewPrompt,
  quoteDetail,
  quotes,
  quoteNew,
  quoteMisc,
  companies,
  priceLists,
  poImports,
  ai,
  settings,
  feedback,
};
